// AsOfPill — "As of <date>" indicator with a green freshness dot. Defaults to
// yesterday (data is end-of-prior-day), computed at render so it never goes
// stale. Sits inline-left of a card/section heading. From the prototype.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatDisplayDate, yesterday } from '../../../utils/format';
import './asof-pill.css';

export function AsOfPill({ date, labelKey = 'reusable.asOfPill.label' }) {
  const { t } = useTranslation();
  // The date itself stays en-US (financial figures and dates are not relocalized,
  // CLAUDE.md §16) — only the surrounding label translates.
  //
  // `formatDisplayDate` (not `formatDate`) because callers pass BOTH shapes: a bare
  // ISO string straight off the payload's `asOfDate`, and a Date from `yesterday()`.
  // A bare ISO parses as UTC midnight, so local getters reported the previous day in
  // every negative-offset timezone — an off-by-one as-of on financial figures.
  const d = date || yesterday();
  return (
    <span className="asof-pill">
      <span className="asof-pill__dot" aria-hidden="true" />
      {t(labelKey, { date: formatDisplayDate(d) })}
    </span>
  );
}

AsOfPill.propTypes = {
  /** Override the displayed date. Defaults to yesterday. */
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  /**
   * Translation key for the surrounding label, so a surface can word freshness its own
   * way (the sponsor dashboard says "as of" in lower case). Defaults to the shared copy,
   * leaving every existing caller untouched.
   */
  labelKey: PropTypes.string,
};

export default AsOfPill;
